import "../TableOuterBox.css";
import "./ObjectEstimateViewer.css";

import { useEffect, useLayoutEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";

import { Stack } from "@mui/material";

import AlertLoading from "components/AlertLoading";
import HeaderVisibleButton from "components/HeaderVisibleButton";
import Table from "components/Table/Table";
import LabelNormWithUnder from "components/UI/LabelNormWithUnder";
import { getObjectEstimateTree, protectObjEstmFull, setObjFetchStatus, setTableData } from "slices/object_estimate";
import { setReGetProtocol } from "slices/protocol";
import { clearClickedTableCtrlRows, setCurrentEstmDocId, setCurrentPage } from "slices/ribbon";

import EstmHeaderTitleButtons from "../components/EstmHeaderTitleButtons/EstmHeaderTitleButtons";
import { ObjectEstmFooterSignatures } from "./components/ObjectEstmFooterSignatures/ObjectEstmFooterSignatures";
import ObjectEstimateTableColumns from "./ObjectEstimateTableColumns";

export const ObjectEstimateViewer = (props) => {
	const dispatch = useDispatch();
	const [fullVisible, setFullVisible] = useState(true);
	const columnsData = ObjectEstimateTableColumns();
	const headerData = useSelector((state) => state.objectEstimate.headerData);
	const rowsData = useSelector((state) => state.objectEstimate.tableData);
	const fetchStatus = useSelector((state) => state.objectEstimate.fetchStatus);
	const fetchStatusText = useSelector((state) => state.objectEstimate.fetchStatusText);
	const reGetProtocol = useSelector((state) => state.protocol.reGetProtocol);
	const { id } = useParams();
	const headBlock = useRef();
	const headScrollControllBlock = useRef();
	const headBlock1 = useRef();
	const headBlock3 = useRef();
	const maxHeight = "150px";

	useEffect(() => {
		dispatch(getObjectEstimateTree(id));
	}, [dispatch, id]);

	useEffect(() => {
		if (reGetProtocol === true) {
			dispatch(getObjectEstimateTree(id));
			dispatch(setReGetProtocol(false));
		}
	}, [reGetProtocol]); // eslint-disable-line react-hooks/exhaustive-deps

	useLayoutEffect(() => {
		dispatch(setCurrentPage("ObjectEstimateViewer"));
		dispatch(setCurrentEstmDocId(id));
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	useEffect(() => {
		return () => dispatch(clearClickedTableCtrlRows());
	}, []); // eslint-disable-line react-hooks/exhaustive-deps

	const handleSetFullVisible = () => {
		const toggleMaxHeight = (block) => {
			if (block) {
				block.style.maxHeight = fullVisible ? 0 : maxHeight;
			}
		};
		[headBlock1?.current, headBlock3?.current].forEach(toggleMaxHeight);
		setFullVisible(!fullVisible);
	};

	return (
		<div className="TableOuterBox OsrTable" type="ObjectEstimate">
			<div className="TableOuterHead" ref={headBlock}>
				<div className="OuterHeadHidable" ref={headBlock1}>
					<div>
						<LabelNormWithUnder norm="Наименование стройки" under={headerData["main_name"]} />
						<LabelNormWithUnder norm="Наименование объекта капитального строительства" under={headerData["name"]} />
					</div>
				</div>
				<div className="TableOuterHeadMainTitle">
					<div className="HeadFlex">
						<div className="TitleLeft"></div>
						<div className="TitleCenter">
							<span>ОБЪЕКТНЫЙ СМЕТНЫЙ РАСЧЕТ (СМЕТА) № {headerData["num"]}</span>
							<HeaderVisibleButton fullVisible={fullVisible} f_handleVisible={handleSetFullVisible} />
						</div>
						<div className="TitleRight">
							<EstmHeaderTitleButtons data={headerData} id={id} estm_type="osr" f_protect={protectObjEstmFull} />
						</div>
					</div>
				</div>
				<div className="OuterHeadHidable" ref={headBlock3}>
					<div>
						<LabelNormWithUnder norm="Основание" under={headerData["reason"]} />
						<LabelNormWithUnder norm="Сметная стоимость" under={headerData["full_cost"] + " тыс.руб."} />
						<LabelNormWithUnder norm="Расчетный измеритель объекта капитального строительства" under={headerData["quantity_unit"]} />
						<LabelNormWithUnder
							norm="Показатель единичной стоимости на расчетный измеритель объекта капитального строительства"
							under={headerData["price_per_unit"] + " тыс.руб."}
						/>
						<div className="TableOuterHeadFlex" ref={headScrollControllBlock}>
							<LabelNormWithUnder norm="Составлен в текущем уровне цен" under={headerData["price_level_print"]} />
							<div className="TableOuterHeadPanel">
								<Stack direction="row" spacing={0}>
									<div className="TableOuterHeadPanelElement"></div>
								</Stack>
							</div>
						</div>
					</div>
				</div>
			</div>
			<Table
				rowData={rowsData}
				columnsData={columnsData}
				scrollBlock={props.scrollBlock}
				options={{
					selectOptions: {
						controlled: true,
						uncontrolled: false,
						multiple: false,
						expandOnSelect: {
							columnsName: ["name", "reason"],
							fontSize: "12px",
							tableClass: "OsrTable",
						},
						aggrFooterCellSum: {
							columnsName: ["building", "mounting", "equipment", "other", "total"],
						},
					},
					displayOptions: {
						displayScrollDelay: 30,
						additinalScrollHeight: 200,
						newResizableColumns: true,
						headBlock: headBlock,
						localStoragePageKey: "OsrViewer",
						columnsWithMinWidth: [{ name: "name", minWidth: "350px" }],
					},
					tableType: "osr",
					funcCall: "dispatch",
				}}
				funcs={{
					setTableData: ({ newTableData }) => dispatch(setTableData(newTableData)),
				}}
			/>

			<div className="TableHeaderBlankPlaceHolder"></div>
			{rowsData != null && rowsData.length ? <ObjectEstmFooterSignatures data={headerData} /> : <></>}

			<AlertLoading fetchStatus={fetchStatus} fetchStatusText={fetchStatusText} func={setObjFetchStatus} />
		</div>
	);
};
